import { useCallback, useEffect } from 'react'
import { toast } from '@sales-center/components'

import {
  useUpdateOpportunityStatus,
  useCloseWinOpportunity,
} from '@user/store/opportunity'
import {
  useCWQDialogContext,
  openDialogActionCreator as openDialog,
  closeDialogActionCreator as closeDialog,
} from '@user/components/SoldServices'

export function useUpdateOppStatus(
  opportunityId: number,
  closedWonStageId: number = -1,
  closedLostStageId: number = -1,
) {
  const { status: updateStatus, onUpdateStatus } = useUpdateOpportunityStatus()

  const { onCloseWin, canCloseWin, isCloseable, closeWinStatus } =
    useCloseWinOpportunity(opportunityId)

  const [{ activeDialog }, dispatch] = useCWQDialogContext()

  const onChangeStatus = useCallback(
    (salesFunnelStageId?: number) => {
      if (
        !salesFunnelStageId ||
        closedWonStageId === -1 ||
        closedLostStageId === -1
      )
        return

      if (salesFunnelStageId === closedWonStageId) {
        canCloseWin()
      } else if (salesFunnelStageId === closedLostStageId) {
        dispatch(openDialog('closeLose'))
      } else {
        onUpdateStatus({
          opportunityId,
          salesFunnelStageId,
          reasonId: 0,
          customReason: '',
        })
      }
    },
    [
      closedWonStageId,
      closedLostStageId,
      canCloseWin,
      dispatch,
      onUpdateStatus,
      opportunityId,
    ],
  )

  const closeActiveDialog = useCallback(
    () => dispatch(closeDialog()),
    [dispatch],
  )

  useEffect(() => {
    if (updateStatus === 'fail') {
      toast.error('Failed to update opportunity stage.')
    } else if (updateStatus === 'success') {
      dispatch(closeDialog())
    }
  }, [dispatch, updateStatus])

  useEffect(() => {
    if (isCloseable === 'pending') return

    if (isCloseable) {
      dispatch(openDialog('ssq'))
    } else {
      dispatch(openDialog('closeWinError'))
    }
  }, [dispatch, isCloseable])

  useEffect(() => {
    if (closeWinStatus === 'success') dispatch(closeDialog())
  }, [closeWinStatus, dispatch])

  const loading = closeWinStatus === 'pending' || updateStatus === 'pending'

  return {
    loading,
    activeDialog,
    updateStatus,
    closeWinStatus,
    onCloseWin,
    onChangeStatus,
    closeActiveDialog,
  }
}
